'use client';

import { useEffect, useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { OverflowGroupClassification } from '@/types/tournament.model';
import {
  OptionCardsField,
  OVERFLOW_CLASSIFICATION_OPTIONS,
} from '@/features/tournament-wizard/blocks/fixture-config';

interface EditOverflowGroupClassificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentClassification: OverflowGroupClassification;
  onSave: (value: OverflowGroupClassification) => Promise<boolean>;
  isLoading: boolean;
}

export function EditOverflowGroupClassificationModal({
  isOpen,
  onClose,
  currentClassification,
  onSave,
  isLoading,
}: EditOverflowGroupClassificationModalProps) {
  const [classification, setClassification] = useState(currentClassification);

  useEffect(() => {
    if (!isOpen) return;
    setClassification(currentClassification);
  }, [isOpen, currentClassification]);

  const handleSave = async () => {
    await onSave(classification);
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Grupos ocasionales de 4 y clasificados"
      onSave={handleSave}
      isLoading={isLoading}
    >
      <div className="py-4">
        <p className="mb-4 text-sm text-muted-foreground">
          Solo formato Corto con grupos + eliminatorias. Afecta cómo se cuentan
          los clasificados cuando el fixture arma grupos de 4 equipos.
        </p>
        <OptionCardsField
          label="Clasificados en grupos de 4"
          value={classification}
          onChange={setClassification}
          options={OVERFLOW_CLASSIFICATION_OPTIONS}
          disabled={isLoading}
        />
      </div>
    </EditModal>
  );
}
